module.exports = __webpack_public_path__ + "static/media/stpay_logo_white.39476960.png";